import { render } from "./ItemContent.vue?vue&type=template&id=a0037f66"
import script from "./ItemContent.vue?vue&type=script&lang=js"
export * from "./ItemContent.vue?vue&type=script&lang=js"

import "./ItemContent.vue?vue&type=style&index=0&id=a0037f66&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__